export default "__VITE_ASSET__dM1RyeJk__"